import React, {
  FunctionComponent,
  useEffect,
  useState
} from "react";
import styles from "./CallRecordingHeader.module.css";
import { connect, useDispatch } from "react-redux";
import ToggleButton from "../ToggleButton/ToggleButton";
import HeadphoneImage from "../../../src/Assets/Images/headphones.png";
import BetaImage from "../../../src/Assets/Images/beta.png";
import { v4 as uuidv4 } from 'uuid';
import Tooltip from "../CallRecordingDisabledTooltip/CallRecordingDisabledTooltip";
import { updateCallRecordingStatus } from "../../Services/organizations";
import Loading from "../Loading/Loading";

type props = {
  checked?: any;
  onChange?: any;
  id?: any;
  customStyles?: any;
  openCallRecordingDescriptionModal?: any;
  setOpenCallRecordingDescriptionModal?: any;
  // organizationData?: any;
  user?:any;
  callRecordingModule?: any;
};

const CallRecordingHeader: FunctionComponent<props> = ({
  checked,
  onChange,
  id,
  customStyles,
  openCallRecordingDescriptionModal,
  setOpenCallRecordingDescriptionModal,
  // organizationData,
  user,
  callRecordingModule
}) => {
  const [isCallRecordingEnabled, setIsCallRecordingEnabled] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isCallRecordingModuleSubscribed, setIsCallRecordingModuleSubscribed] = useState(true);
  const [load, setLoad] = useState(false);
  const dispatcher = useDispatch();
  const callRecordingUpdate = (status: any) => {
    setIsCallRecordingEnabled(!isCallRecordingEnabled)
    updateCallRecordingStatus(user.organization_id, status, setLoad, dispatcher)
    // updateCallRecordingStatus();
  }

  useEffect(() => {
    let callRecordingEnabled = callRecordingModule && (callRecordingModule.is_call_recording_enabled && callRecordingModule.is_call_recording_subscribed) ? callRecordingModule.is_call_recording_enabled : false;
    let callRecordingSubscribed = callRecordingModule && callRecordingModule.is_call_recording_subscribed ? callRecordingModule.is_call_recording_subscribed : false;
    setIsCallRecordingEnabled(callRecordingEnabled);
    setIsCallRecordingModuleSubscribed(callRecordingSubscribed);
  }, [callRecordingModule])

  return (
    <div className={styles.callRecordingHeader}>
      {/* <CallRecordingDescriptionModal
        open={openCallRecordingDescriptionModal}
        close={() =>{setOpenCallRecordingDescriptionModal(false)}}
      /> */}
      {load === true && <Loading />}
      <Tooltip showTooltip={showTooltip} setShowTooltip={setShowTooltip} />
      <div className={styles.callRecordingLabel}>
        <img className={styles.betaImg} src={BetaImage} alt="beta-feature" />
        <img className={styles.headphoneImg} src={HeadphoneImage} alt="headphone-icon" />
        <p className={styles.introducingCallRecording}>Introducing Call Recordings</p>
        <p className={styles.knowMore} onClick={() => {
          setOpenCallRecordingDescriptionModal(true)
        }}>Know More</p>
        <div className={styles.toggleContainer} style={isCallRecordingModuleSubscribed ? { opacity: 1 } : { opacity: 0.6 }}>
          <p className={styles.toggleLabel}>{isCallRecordingEnabled ? "Disable" : "Enable"}</p>
          <ToggleButton
            checked={isCallRecordingEnabled}
            onChange={() => {
              isCallRecordingModuleSubscribed ? callRecordingUpdate(!isCallRecordingEnabled) : setShowTooltip(true);
            }}
            id={uuidv4()}
            customStyles={{ backgroundColor: isCallRecordingEnabled ? "#269f9f" : "#e8e8e8", border: isCallRecordingEnabled ? "none" : "2px solid #d7d7d7" }}
          />
        </div>
        {/* <h1>Call Recording Header</h1> */}
        {/* <div className={styles.callRecordingLabel2}></div> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    // snackbarData: state.snackbar,
    // theme:state.theme.isLightMode
    user: state.user.data,
    // organizationData: state.organization.organizationData,
    callRecordingModule: state.callRecordingModule
  };
};

export default connect(mapStateToProps)(CallRecordingHeader);
